export default "__VITE_ASSET__DRmyvfxA__"